import React from 'react'

import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea'
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import Upload from '../../componentes/Upload/Index';
import FileList from '../../componentes/FileList';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown';
import { uniqueId } from "lodash";
import filesize from 'filesize';
import { MultiSelect } from 'primereact/multiselect'
import { InputMask } from 'primereact/inputmask';

import NavBar from '../../componentes/Navbar'
import PushService from '../../app/service/PushService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import HistoricoProcessoService from '../../app/service/HistoricoProcessoService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import AtividadeService from '../../app/service/AtividadeService'

class Push extends React.Component {
  constructor(props) {
    super(props)

    this.pushService = new PushService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.statusProcessualService = new StatusProcessualService();
    this.historicoProcessoService = new HistoricoProcessoService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.atividadeService = new AtividadeService();

    this.onChangeOculto = this.onChangeOculto.bind(this);
    this.onChangeClassificacao = this.onChangeClassificacao.bind(this);
    this.onChangeOrdenacao = this.onChangeOrdenacao.bind(this);
    this.acoes = this.acoes.bind(this);
    this.aceptIncluirNoHistorico = this.aceptIncluirNoHistorico.bind(this);
    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
    this.renderFooterArquivosTj = this.renderFooterArquivosTj.bind(this);

    this.state = {
      movimentos: [],
      movimento: null,
      consultaPorGrupos: '',
      gruposTrabalho: [],
      gruposLista: [],
      consultaPorDataInicial: '',
      consultaPorDataFinal: '',
      statusProcessuais: [],
      statusProcessuaisLista: [],
      consultaPorProcesso: '',
      consultaPorPasta: '',
      consultaPorMovimentacao: '',
      consultaPorOculto: '',
      classificacao: null,
      ordenacao: null,
      selectPush: null,
      openSpinner: false,
      //Cadastro de nova Atividade
      titulo: '',
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      tipo: '',
      status: '',
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      displayAtividade: false,
      wait: false,
      tipoAtividade: null,
      grupos: [],
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      responsaveis: [],
      responsavel: null,
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      processos: [],
      processo: null,
      bloqueiaGrupo: false,
      detail: '',
      consultaProcessoTopo: '',
      //Upload de Arquivos
      upLoadFiles: [],
      nome: '',
      descricao: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      //Arquivos do TJ
      modalArquivosTj: false,
      arquivosControle: [],
      dataProcessamentoPush: ''
    };

    this.ocultos = [
      {codigo: 'P', nome: 'Visíveis'},
      {codigo: 'A', nome: 'Ocultos'},
      {codigo: 'T', nome: 'Todos'}
    ];

    this.classificacao = [
      {codigo: '1', nome: 'Dt, Movimento'},
      {codigo: '2', nome: 'Movimentação'},
      {codigo: '3', nome: 'Autor'},
      {codigo: '4', nome: 'Réu'},
      {codigo: '5', nome: 'St. Processual'},
      {codigo: '6', nome: 'Gp. Trabalho'}
    ];

    this.ordem = [
      {codigo: '1', nome: 'Ascendente'},
      {codigo: '2', nome: 'Decrescente'}
    ]
  }

  carregarCarquivo = () => {
    this.setState({arquivosControle: []});
    this.abrirModalAtividade('modalArquivosTj')
  }

  //Upload de Documentos
  handleUploadTj = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processarArquivoTj);
  }

  updateFile = (id, data) => {
    this.setState({upLoadFiles: this.state.upLoadFiles.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processarArquivoTj = async (upLoadFile) => {
    const data = new FormData();
    data.append('file',upLoadFile.file);
    await this.pushService.carregarArquivosTj(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })

      await this.listarArquivosNaoProcessados();
  }

  listarArquivosNaoProcessados = async () => {
    await this.pushService.listarArquivosTj()
      .then(response => {
        this.setState({arquivosControle: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Carregamento de Arquivos TJ', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  listarGruposTrabalho = async () => { 
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
        this.setState({gruposLista: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Movimentações do Push', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarStatusProcessuais = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.statusProcessualService.listarStatusProcessual(usuarioLogado.empresa.codigo)
      .then(response =>  {
        this.setState({statusProcessuais: response.data});
        this.setState({statusProcessuaisLista: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Movimentações do Push', detail:`${this.state.detail}`, life: 4000});
      })
  }

  onChangeOculto(e) {
    this.setState({consultaPorOculto: e.value});
  }

  onChangeClassificacao(e) {
    this.setState({classificacao: e.value});
  }

  onChangeOrdenacao(e) {
    this.setState({ordenacao: e.value});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  consultarMovimentos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    let dataCarregamento = null;
    let dataInicial = null;
    let dataFinal = null;
    
    if(this.state.consultaPorDataInicial == '' ||  this.state.consultaPorDataInicial == null 
       && this.state.consultaPorDataFinal == '' || this.state.consultaPorDataFinal == null) {
      const dataAtual = new Date();
      dataCarregamento = dataAtual;
      var month = this.pad2(dataCarregamento.getMonth()+1);//months (0-11)
      var day = this.pad2(dataCarregamento.getDate());//day (1-31)
      var year= dataCarregamento.getFullYear();
      dataCarregamento =  year+"-"+month+"-"+day;
    } else {
      //Data Inicial
      var dateInicial = this.state.consultaPorDataInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataInicial =  year+"-"+month+"-"+day;
      //Data Final
      var dateFinal = this.state.consultaPorDataFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataFinal =  year+"-"+month+"-"+day;
    }    

    //Filtro pelos grupos de Trabalhos
    let codigosGrupos = '';
    for(let i = 0; i < this.state.gruposLista.length; i++) {
      if(i < this.state.gruposLista.length -1) {
        codigosGrupos = codigosGrupos + this.state.gruposLista[i].codigo + ",";
      } else {
        codigosGrupos = codigosGrupos + this.state.gruposLista[i].codigo;
      }
    }

    //Filtro por Status Processual
    let codigosStatus = '';
    for(let i = 0; i < this.state.statusProcessuaisLista.length; i++) {
      if(i < this.state.statusProcessuaisLista.length -1) {
        codigosStatus = codigosStatus + this.state.statusProcessuaisLista[i].codigo + ",";
      } else {
        codigosStatus = codigosStatus + this.state.statusProcessuaisLista[i].codigo;
      }
    }

    let classific = null;
    let ordem = null;
    if(this.state.classificacao == null) {
      classific = '1'
    }

    if(this.state.ordenacao == null) {
      ordem = '2'
    }

    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      grupos: codigosGrupos,
      status: codigosStatus,
      processo: this.state.processo,
      pasta: this.state.pasta,
      movimentacao: this.state.movimentacao,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      dataCarregamento: dataCarregamento,
      classificacao: classific,
      ordem: ordem
    }

    this.setState({openSpinner: true});
    await this.pushService.consultarMovimentos(filtro)
      .then(response => {
        console.log('Dados dos movimentos: ' + response.data);
        this.setState({movimentos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Movimentações do Push', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner: false});
      });
      this.setState({openSpinner: false});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="fas fa-tasks" className="p-button-rounded p-button-text" 
                tooltip="Criar Atividade"
                onClick={() => this.incluirAtividade(rowData)}
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="fas fa-comment-alt" className="p-button-rounded p-button-text"
                tooltip="Incluir no Histórico"
                onClick={() => this.confirmaIncluirHistorico(rowData)}
                disabled={rowData.temHistorico == 'S' ? false : true}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  atualizaMovimentoTemHistorico = async (movimento) => {
    const movimentoAlterado = {
      codigo: movimento.codigo,
      temHistorico: 'N'
    }

    await this.pushService.atualizaMovimento(movimentoAlterado)
      .then(response => {
        this.consultarMovimentos();
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Movimentações do Push - Atualização', detail:`${this.state.detail}`, life: 4000});
      })
  }

  incluirNoHistorico = async (movimento) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const dataAtual = new Date();
    var dataCarregamento = dataAtual;
    var month = this.pad2(dataCarregamento.getMonth()+1);//months (0-11)
    var day = this.pad2(dataCarregamento.getDate());//day (1-31)
    var year= dataCarregamento.getFullYear();
    dataCarregamento =  year+"-"+month+"-"+day;

    const processo = {
      codigo: movimento.cdprocesso
    }
    const historico = {
      processo: processo,
      historico: movimento.dsmovimentacao,
      usuario: usuarioLogado,
      dataHistorico: dataCarregamento,
      dataOcorrencia: movimento.dataRegistroHistorico
    };

    this.setState({openSpinner: true});
    await this.historicoProcessoService.incluirHistorico(historico)
      .then(response => {
        this.atualizaMovimentoTemHistorico(movimento);
        this.toast.show({severity:'success', summary: 'Movimentações do Push', detail:'Histórico incluído com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Movimentações do Push', detail:`${this.state.detail}`, life: 4000});
      });

    this.setState({openSpinner: false});
  }

  aceptIncluirNoHistorico() {
    this.incluirNoHistorico(this.state.movimento);
  }

  confirmaIncluirHistorico(movimento) {
      this.setState({movimento: movimento});
      confirmDialog({
          message: 'Deseja realmente incluir esta movimentação no histórico ?',
          header: 'Inclusão de Histórico',
          icon: 'pi pi-question-circle',
          acceptClassName: 'p-button-information',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: this.aceptIncluirNoHistorico,
          reject: this.reject
      });
  }

  listarResponsaveis = async(grupo) => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(grupo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async(grupo) => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(grupo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  limparCamposAtividade = () => {
    this.setState({processo: null});
    this.setState({titulo: ''});
    this.setState({descricao: ''});
    this.setState({dtLimite: ''});
    this.setState({dtFatal: ''});
    this.setState({tipo: ''});
    this.setState({status: ''});
    this.setState({responsavel: null});
    this.setState({interessado: null});
    this.setState({responsaveis: []});
    this.setState({selectGrupo: null});
    this.setState({selectSubGrupo: null});
  }

  cadastrarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.titulo == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '') {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        tipoTarefa = 'A'
      } else {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day;
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '') {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    //Responsaveis
    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    }

    //Interessados
    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    } else {
      interessados = null;
    }

    const cadastroAtividade = {
      atividade: {
        titulo: this.state.titulo,
        processo: this.state.processo,
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        status: {
          codigo: 1 // Ativo
        }
      },
      responsaveis: this.state.responsavel,
      interessados: this.state.interessado
    }

    await this.atividadeService.cadastrarAtividade(cadastroAtividade).
      then(response => {
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
    }).catch(error => {
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Cadastrar"
                    disabled={this.state.desabilitaBotao}
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarAtividade}/>
            &nbsp;
            <Button label="Anexar" 
                    disabled={this.state.desabilitaBotao}
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalAnexo('displayAnexo')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Cancelar" 
                    disabled={this.state.desabilitaBotao}
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  renderFooterArquivosTj(name) {
    return (
        
        <div className="left">
            <Button label="processar" 
                    className="p-button-primary p-button-text"
                    onClick={this.processarArquivos}/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  abrirModalAnexo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  async incluirAtividade(movimento) {
    const processo = {
      codigo: movimento.cdprocesso
    }
    this.excluirArquivosTemp();
    this.setState({processo: processo});
    this.consultarSubGrupos(movimento.cdgrupo);
    this.setState({grupoTrabalhoNome: movimento.nogrupo});
    this.setState({pesquisaProcesso: movimento.nrcnj});
    this.listarResponsaveis(movimento.cdgrupo);
    this.listarInteressados(movimento.cdgrupo);
    this.limparCamposAtividade();
    this.abrirModalAtividade('displayAtividade');
  }

  abrirModalAtividade(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  excluirArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoAtividadeService.excluirArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        console.log('Arquivos Temporários excluídos');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarSubGrupos = async(codigo) => {
    await this.grupoTrabalhoService.listarSubGrupos(codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  processarArquivos = async () => {
    this.setState({openSpinner: true});
    await this.pushService.processarArquivos(this.state.dataProcessamentoPush)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Push - Processamento de Arquivos', detail:'Processo Finalizado', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'ArqPush - Processamento de Arquivosuivos', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarGruposTrabalho();
    await this.listarStatusProcessuais();
    await this.consultarMovimentos();
    this.setState({openSpinner: false});
  }

  render() {
    const { upLoadFiles } = this.state;
    return(
      <>
        <NavBar />
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-level-down-alt"></i>
                        <span> Movimentações do Push</span>
                      </h3>  
                    </div>
                    <div className="card-body">    
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <MultiSelect inputId="idGrupos" 
                                        value={this.state.gruposLista} 
                                        options={this.state.gruposTrabalho} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ gruposLista: e.value })} 
                                        filter showClear filterBy="nome"
                                        placeholder="Grupos de Trabalho"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                              <MultiSelect inputId="idStatus" 
                                          value={this.state.statusProcessuaisLista} 
                                          options={this.state.statusProcessuais} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ statusProcessuaisLista: e.value })} 
                                          filter showClear filterBy="descricao"
                                          placeholder="Status Processuais"
                                          optionLabel="descricao" />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <InputText id="idConsultaPorProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaPorProcesso}
                                      onChange={e => this.setState({consultaPorProcesso: e.target.value})}
                                      placeholder="Número do Processo"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <Calendar id="idConsultaPorDataInicial" 
                                      value={this.state.consultaPorDataInicial} 
                                      onChange={(e) => this.setState({ consultaPorDataInicial: e.value })} 
                                      locale="es"
                                      style={{height: '32px', width: '115px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Dt Inicial"
                                      mask="99/99/9999"/>
                            &nbsp;
                            <Calendar id="idConsultaPorDataFinal" 
                                      value={this.state.consultaPorDataFinal} 
                                      onChange={(e) => this.setState({ consultaPorDataFinal: e.value })} 
                                      locale="es"
                                      style={{height: '32px', width: '115px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Dt Final"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <InputText id="idConsultaPorPasta" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaPorPasta}
                                      placeholder="Pasta"
                                      onChange={e => this.setState({consultaPorPasta: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <InputText id="idConsultaPorMovimentacao" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaPorMovimentacao}
                                      placeholder="Movimentação"
                                      onChange={e => this.setState({consultaPorMovimentacao: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <Dropdown value={this.state.consultaPorOculto} 
                                        options={this.ocultos} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        onChange={this.onChangeOculto}
                                        id="idVisivelOculto"
                                        placeholder="Visível/Oculto"
                                        className="p-inputtext-sm p-d-block p-mb-0"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <Dropdown value={this.state.classificacao} 
                                      options={this.classificacao} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeClassificacao}
                                      id="idClassificacao"
                                      placeholder="Classificação"
                                      className="p-inputtext-sm p-d-block p-mb-0"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <Dropdown value={this.state.ordenacao} 
                                        options={this.ordem} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        onChange={this.onChangeOrdenacao}
                                        id="idOrdenação"
                                        placeholder="Ordenação"
                                        className="p-inputtext-sm p-d-block p-mb-0"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-1">
                          <div className="form-group">
                            <Button style={{height: '32px'}} type="button" className="p-button-secondary p-button-text p-button-sm" 
                                  onClick={this.consultarMovimentos}>
                              <i className="fas fa-search"></i>&nbsp;&nbsp;Consultar</Button>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <Button style={{height: '32px'}} type="button" className="p-button-secondary p-button-text p-button-sm" 
                                  onClick={this.consultarMovimentos}>
                              <i className="fa fas fa-eraser"></i>&nbsp;&nbsp;Limpar</Button>
                          </div>
                        </div>
                         <div className="col-md-1">
                          <div className="form-group">
                            <Button style={{height: '32px'}} type="button" className="p-button-secondary p-button-text p-button-sm" 
                                  onClick={this.carregarCarquivo}>
                              <i className="fa fas fa-eraser"></i>&nbsp;&nbsp;Carregar Arquivos</Button>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <DataTable value={this.state.movimentos}  paginator responsiveLayout="scroll"
                              selection={this.state.selectPush} onSelectionChange={(e) => this.setState({ selectPush: e.value })}
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              emptyMessage="Nenhuma Movimentação"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                              <Column field="nrpasta" header="Pasta" style={{width: '200px'}}></Column> 
                              <Column field="nrcnj" header="CNJ" style={{width: '200px'}}></Column>
                              <Column field="autor" header="Autor" style={{width: '200px'}}></Column> 
                              <Column field="reu" header="Réu" style={{width: '200px'}}></Column> 
                              <Column field="nosituacao" header="St. Processual" style={{width: '200px'}}></Column> 
                              <Column field="dtUltimaMovimentacao" header="Dt. Ult. Mov." style={{width: '200px'}}></Column> 
                              <Column field="ultimaMovimentacao" header="Ult. Mov." style={{width: '200px'}}></Column> 
                              <Column field="dtMovimentacao" header="Dt. Mov." style={{width: '200px'}}></Column> 
                              <Column field="dsmovimentacao" header="Movimentação" style={{width: '200px'}}></Column> 
                              <Column body={this.acoes} exportable={false} style={{width: '150px'}} header="Ações"></Column>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/**Aqui entra o modal de atividade */}
          <Dialog header="Alterar Atividade" autoComplete="nope"
                  visible={this.state.displayAtividade} 
                  style={{ width: '43vw' }} 
                  footer={this.renderFooterAtividade('displayAtividade')} 
                  onHide={() => this.fecharModalAtividade('displayAtividade')}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <InputText id="titulo" 
                                style={{width: '100%', height: '32px'}}
                                type="text" 
                                autoComplete="nope"
                                value={this.state.titulo}
                                onChange={e => this.setState({titulo: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"
                                placeholder="Título"/>
                  </div>
                </div>
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <InputText id="processo" style={{width: '100%', height: '32px'}}
                              type="text"
                              disabled="true"
                              value={this.state.pesquisaProcesso}
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                  <InputText id="processo" style={{width: '100%', height: '32px'}}
                              type="text"
                              disabled="true"
                              value={this.state.grupoTrabalhoNome}
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                    options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                    optionLabel="nome" 
                    emptyMessage=" "
                    filter showClear filterBy="nome"
                    onChange={this.onSubGrupoChange}
                    id="subGrupoTrabalho"
                    className="p-inputtext-sm p-d-block p-mb-1"
                    placeholder="Sub-Grupo de Trabalho"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <MultiSelect inputId="multiselect" 
                                value={this.state.responsavel} 
                                options={this.state.responsaveis} 
                                style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                onChange={(e) => this.setState({ responsavel: e.value })} 
                                filter showClear filterBy="nome"
                                optionLabel="nome" 
                                placeholder="Responsáveis"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <MultiSelect inputId="multiselect" 
                                value={this.state.interessado} 
                                options={this.state.interessados} 
                                style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                onChange={(e) => this.setState({ interessado: e.value })}  
                                filter showClear filterBy="nome"
                                optionLabel="nome" 
                                placeholder="Interssados"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <div className="form-group">
                    <Calendar id="mask" 
                              value={this.state.dtLimite} 
                              onChange={(e) => this.setState({ dtLimite: e.value })} 
                              locale="es"
                              style={{width: '100%', height: '32px'}} 
                              dateFormat="dd/mm/yy"
                              mask="99/99/9999"
                              placeholder="Data Limite"/>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                  <InputMask id="hora" style={{width: '100%', height: '32px'}}
                            type="text"
                            mask="99:99"
                            value={this.state.hora}
                            onChange={e => this.setState({hora: e.target.value})}
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Calendar id="mask" 
                              value={this.state.dtFatal} 
                              onChange={(e) => this.setState({ dtFatal: e.value })} 
                              locale="es"
                              style={{width: '100%', height: '32px'}} 
                              dateFormat="dd/mm/yy"
                              mask="99/99/9999"
                              placeholder="Prazo fatal"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <InputTextarea id="descricao" 
                                    type="text" 
                                    autoComplete="nope"
                                    style={{width: '100%'}} 
                                    value={this.state.descricao}
                                    onChange={e => this.setState({descricao: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"
                                    rows={3} cols={30}
                                    placeholder="Descrição da Atividade"/>
                  </div>
                </div>
              </div>
          </Dialog>
          {/**Aqui Upload de Arquivos */}
          <Dialog header="Carregar Arquivos do TJ" autoComplete="nope"
                visible={this.state.modalArquivosTj} 
                style={{ width: '43vw' }} 
                footer={this.renderFooterArquivosTj('modalArquivosTj')} 
                onHide={() => this.fecharModalAtividade('modalArquivosTj')}>

            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">  
                  <div className="container">
                    
                    <Upload onUpload={this.handleUploadTj}/>
                    {!!upLoadFiles && (
                      <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                    )}
                  
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">  
                  <DataTable value={this.state.arquivosControle}
                             emptyMessage="Nenhuma Movimentação">
                            <Column field="arquivo" header="Arquio"></Column>
                            <Column field="dataRegistro" header="Data Registro"></Column>
                  </DataTable>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <InputMask id="dataProcessamentoPush" style={{width: '100%', height: '32px'}}
                              type="text"
                              mask="99/99/9999"
                              value={this.state.dataProcessamentoPush}
                              onChange={e => this.setState({dataProcessamentoPush: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                </div>
              </div>
            </div>
        </Dialog>
      </div>
      </>
    );
  }
}

Push.contextType = AuthContext;
export default withRouter (Push)